import { gql } from '@apollo/client';

export const ACCOUNT_LAYOUT_QUERY = gql`
  query Account__AccountLayoutQuery($accountId: ID!) {
    me {
      id
      ... on User {
        type
        internalAdminRole
        memberships {
          account {
            id
          }
          user {
            id
          }
        }
      }
    }
    account(id: $accountId) {
      id
      name
      isOnTrial
      secondaryIDs
    }
  }
`;
